// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateLaborAdditiveSummary = laborAdditiveSummary => ({
    laborAdditiveSummary,
    type: actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARY
});



// WEBPACK FOOTER //
// ./src/pip/labor-additive/action-creators/labor-additive-summary.js